module.exports = __webpack_public_path__ + "static/img/xuanzhongshijian.png@2x.858f820f.png";